import React, {useState, useEffect} from "react";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import Select from "react-select"; // Importa o react-select
import ApiService from "../util/ApiService";
import UsersSearch from "../dashboard/calender/UsersSearch";

const SpecialtiesUserModal = ({show, onHide, userInit = false}) => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedSpecialties, setSelectedSpecialties] = useState([]); // Agora armazena múltiplos especialidades
    const [specialties, setSpecialties] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingSearch, setLoadingSearch] = useState(false);

    useEffect(() => {
        if (show) {

            const loadData = async () => {
                await fetchSpecialties(); // aguarda carregar os especialidade
                if (userInit) {
                    setSelectedUser(userInit);
                } else {
                    setSelectedUser(null);
                }
                setSelectedSpecialties([]);

            };
            loadData();


        }
    }, [show]);

    useEffect(() => {
        if (selectedUser) {


            fetchUserDepartmentsSelected();

        }
    }, [selectedUser]);


    const fetchUserDepartmentsSelected = async () => {
        try {
            setLoadingSearch(true);
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}specialties/users-list-selected`,
                {user_id: selectedUser?.value || selectedUser?.id},
                true
            );

            if (response.code === 200) {

                const {data} = ApiService.handleApiResponse(response);


                // Transforma os especialidades retornados para o formato esperado pelo Select
                const selectedDepartmentsFormatted = data.map((dept) => ({
                    value: dept.specialty_id,
                    label: specialties.find((d) => d.id === dept.specialty_id)?.name || `Especialidade ${dept.specialty_id}`
                }));

                setSelectedSpecialties(selectedDepartmentsFormatted); // Define os especialidades selecionados
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingSearch(false);
        }
    };


    const fetchSpecialties = async () => {
        try {
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}specialties/list-specialties`,
                {all: true, status: 'S'},
                true
            );

            if (response.code === 200) {

                const {data} = ApiService.handleApiResponse(response);

                setSpecialties(
                    Array.isArray(data) ? data : []
                );
            } else {
                Swal.fire("Erro", "Erro ao carregar os especialidades.", "error");
            }
        } catch (error) {
            ApiService.handleApiError(error);
            setSpecialties([]);
        }
    };

    const handleSave = async () => {
        if (!selectedUser) {
            Swal.fire("Atenção", "Selecione um usuário antes de salvar.", "warning");
            return;
        }


        setLoading(true);
        try {
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}specialties/register-user-array`,
                {
                    specialty_id: selectedSpecialties.map((dept) => dept.value), // Envia um array de IDs
                    user_id: selectedUser?.value || selectedUser?.id
                },
                true
            );

            if (response.code === 200) {

                const {message, data} = ApiService.handleApiResponse(response);

                let swalMessage = "";

                if (data.added?.length > 0) {
                    swalMessage += `Vinculado com sucesso em <b>${data.added?.length}</b> novo(s) especialidades(s).<br>`;
                }
                if (data.ignored?.length > 0) {
                    swalMessage += `Mantido o(s) <b>${data.ignored.length}</b> especialidade(s) já vínculados.`;
                }

                // Exibir no SweetAlert2
                Swal.fire("Informação", swalMessage, "info").then(() => {
                    onHide(true);
                });
            } else {
                Swal.fire("Erro", "Erro ao registrar o usuário nos especialidades.", "error");
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Especialidade - Vincular plantonista</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="p-3">

                    <div className="mb-3">
                        <UsersSearch initialUser={userInit} onUserSelect={(user) => setSelectedUser(user)}/>
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Especialidade:</label>
                        <div className="d-flex align-items-center">
                            <div className="flex-grow-1">
                                <Select
                                    isMulti // Permite seleção múltipla
                                    options={specialties.map((dept) => ({
                                        value: dept.id,
                                        label: dept.name,
                                    }))}
                                    value={selectedSpecialties}
                                    onChange={setSelectedSpecialties}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Selecionar Especialidade..." // Define o texto interno
                                    menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                    styles={{
                                        menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999
                                        }), // Definindo z-index alto
                                        menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                    }}
                                />
                            </div>
                            {loadingSearch && (
                                <span
                                    className="spinner-border spinner-border-sm ms-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            )}
                        </div>
                    </div>


                </div>

                <div className="d-flex justify-content-end mt-3">
                    <button type="button" className="btn btn-dark" onClick={() => onHide()} disabled={loading}>
                        <i className="fa fa-close"></i> Cancelar
                    </button>
                    <button type="button" className="btn btn-info ms-2" onClick={() => handleSave()} disabled={loading}>

                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"
                                      aria-hidden="true"></span>
                                Salvando...
                            </>
                        ) : (
                            <>
                                <i className="fa fa-plus"></i> Salvar
                            </>
                        )}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    )
        ;
};

export default SpecialtiesUserModal;
